import * as React from 'react';
import {
  BulkActionsToolbar,
  CreateButton,
  Datagrid,
  DateField,
  FunctionField,
  ListBase,
  ListToolbar,
  NumberField,
  Pagination,
  TopToolbar,
  useListContext
} from 'react-admin';
import { cloneElement } from 'react';
import Card from '@mui/material/Card';
import Text from 'antd/lib/typography/Text';
import { useSubscription } from '@apollo/client';

import { AccountScoped } from 'shared/react-admin';
import Dashboard from 'formtopia/react-admin/dashboard';
import { ACCOUNT_FORMS_SUBSCRIPTION } from 'shared/gql'
import AppState from 'shared/app_state';

// const FormFilter = (props) => (
//   <Filter {...props}>
//     <TextInput label="Search By ID" source="id" alwaysOn />
//   </Filter>
// );

export const FormBlock = (form: any) => (
  <div style={{ display: 'flex', flexFlow: 'column nowrap', height: 50, justifyContent: 'center' }}>
    <Text strong>{form.name}</Text>
    <Text type="secondary">{form.key}</Text>
  </div>
);

// export const FList = (props: any) => (
//   <List
//     {...props}
//     // bulkActionButtons={<FormBulkActionButtons />}
//     exporter={false}
//     // filters={<FormFilter />}
//     perPage={25}
//   >
//     <Datagrid rowClick="edit">
//       <FunctionField render={FormBlock} />
//       {/* <ReferenceField label="Form" source="id" reference="forms" link="show">
//         <FunctionField render={FormBlock} />
//       </ReferenceField> */}
//       {/* <TextField source="key" />
//       <TextField source="name" /> */}
//       <NumberField source="entriesCount" label="Entries" />
//       <DateField source="entriesLastAt" label="Last Entry" />
//       <DateField source="createdAt" label="Registered" />
//     </Datagrid>
//   </List>
// );

const ListActions = () => (
  <AccountScoped view="Formtopia Dash Create Button">
    {(accountId: string) => {
      return (
        <TopToolbar>
          <CreateButton sx={{ background: 'rgb(25, 118, 210)', color: 'white', paddingRight: 1, marginBottom: 3, marginTop: 3 }} label="Create New Form" />
        </TopToolbar>
      );
    }}
  </AccountScoped>
);

export const FormList = () => {
  return (
    <FormListLayout actions={<ListActions />}>
      <RealtimeFormListDataGrid />
    </FormListLayout>
  );
};

const FormListLayout = (listProps) => {
  return (
    <AccountScoped view="Formtopia Dash" componentProps={listProps}>
      {(accountId: string, props) => {
        return (
          <ListBase {...props} filter={{ accountId }}>
            <Dashboard accountId={accountId} />
            <ListToolbar filters={props.filters} actions={props.actions} />
            <Card >
              {cloneElement(props.children)}
              <Pagination />
            </Card>
          </ListBase>
        );
      }}
    </AccountScoped>
  );
};

const RealtimeFormListDataGrid = ({ }) => {
  const { refetch: refetchForms } = useListContext()

  useSubscription(ACCOUNT_FORMS_SUBSCRIPTION, {
    variables: { accountId: AppState.getCurrentAccount().id },
    onSubscriptionData: (data) => {
      const { subscriptionData: { data: { accountForms } } } = data

      if (['form_entry_create', 'form_entry_delete', 'form_create', 'form_delete', 'form_update'].includes(accountForms?.payload?.event)) refetchForms()
    }
  })

  return (
    <Datagrid
      rowClick={(id, resource, props) => {
        return `${id}/entries`
      }}
      bulkActionButtons={false}>
      <FunctionField source="Form" render={FormBlock} />
      {/* <ReferenceField label="Form" source="id" reference="forms" link="show">
        <FunctionField render={FormBlock} />
      </ReferenceField> */}
      {/* <TextField source="key" />
      <TextField source="name" /> */}
      <NumberField source="entriesCount" label="Entries" />
      <DateField source="entriesLastAt" label="Last Entry" />
      <DateField source="createdAt" label="Created" />
    </Datagrid>
  )
}
